import Vue from 'vue'
import VueResource from 'vue-resource'
import Multiselect from '../../component/multiselect.vue'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import datePicker from '../../component/datePicker.vue'
import checkbox from '../../component/dccore-form/checkbox.vue'
import Singleselect from '../../component/simple-form/singleselect.vue'
import moment from 'moment'
import 'moment/locale/pl'

if ($('#warehouse_stocks_form').length) {
  Vue.use(VueResource)
  new Vue({
    el: '#warehouse_stocks_form',
    components: {
      RingLoader,
      datePicker,
      Multiselect,
      checkbox,
      Singleselect
    },
    mixins: [mixins],
    data: {
      loading: 0,
      searchForm: {
        date: moment().add(-1, 'days').locale('pl').format('YYYY-MM-DD'),
        mode: 'all',
        supplyWarehouse: null
      },
      formHash: null,
      modes: ['all', 'materials'],
      supplyWarehouses: [{ 'id': null,
        name: Translator.trans('warehouse.stocks.all_supply_warehouses') }]
    },
    computed: {
      date: function () {
        return this.searchForm.date
      },
      mode: function () {
        return this.searchForm.mode
      },
      supplyWarehouse: function () {
        return this.searchForm.supplyWarehouse
      },
    },
    mounted: function () {
      this.loading++
      if ($('#form_hash').length) {
        this.formHash = $('#form_hash').val()
      }
      this.getSupplyWarehouses()
    },
    methods: {
      search() {
        // runs APYDataGrid function
        // APYDataGrid creates function like [form hash]_submitForm

        $('.grid-filter-input-query-from[name=mode]').val(this.searchForm.mode)
        $('.grid-filter-input-query-from[name=supplyWarehouse]').val(this.searchForm.supplyWarehouse)

        window[`${this.formHash}_submitForm`](new Event(''))
      },
      translateMode(name) {
        return Translator.trans(`warehouse.stocks.modes.${name}`)
      },
      getSupplyWarehouses() {
        let url = Routing.generate('api_get_warehouse_supply_warehouses')
        Vue.http.get(url).then(response => {
          this.supplyWarehouses = [...this.supplyWarehouses, ...response.data]
          this.loading--
        })
      }
    }
  })
}
